import { Box, Button, ButtonGroup, Card, Heading, Image, Paragraph } from '@zillow/constellation-10';
import { APPLICATIONS_FAQ_URL, EXTERNAL_URLS, getExternalUrl } from '../../constants/urls';
import rentalSearchLight from '../../images/rental-search-light.svg';
import { RENTAL_APPLICATION_PRICE } from '../../constants/applicationsConstants';

export function ApplicationsEmptyState() {
  return (
    <Card tone="neutral" elevated={false} css={{ paddingInline: 'looser', paddingBlock: 'loosest', textAlign: 'left' }}>
      <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
        <Image src={rentalSearchLight} alt="" role="presentation" width={120} height={120} />
      </Box>
      <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'tightest' }}>
        Find a rental you love
      </Heading>
      <Paragraph css={{ marginBottom: 'default' }}>
        {`Browse and apply to as many participating Zillow listings as you’d like — just ${RENTAL_APPLICATION_PRICE} for 30 days.`}
      </Paragraph>
      <ButtonGroup
        aria-label="Empty state actions"
        orientation="horizontal"
        css={{
          flexDirection: { base: 'column', md: 'row' },
          alignItems: { base: 'stretch', md: 'start' },
        }}
      >
        <Button asChild tone="brand" emphasis="filled">
          <a href={getExternalUrl(EXTERNAL_URLS.RENTALS_SEARCH_PAGE_URL)}>View all rentals</a>
        </Button>
        <Button asChild tone="brand" emphasis="outlined">
          <a href={APPLICATIONS_FAQ_URL} target="_blank" rel="noopener noreferrer">
            Learn more
          </a>
        </Button>
      </ButtonGroup>
    </Card>
  );
}
